import { MenuItem } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { CompetenceModel } from 'projects/core/src/lib/models/competence.model';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-competence-list',
  templateUrl: './competence-list.component.html',
  styleUrls: ['./competence-list.component.scss']
})
export class CompetenceListComponent extends BaseList implements OnInit {

  private tempOrder: Array<number> = [];

  public competences: Array<CompetenceModel> = [];
  public loading = false;
  public messages: Array<any> = [];
  public items: Array<MenuItem> = [];
  public inOrdering = false;
  public submitting = false;
  public apiUrl = '/competences';

  protected rightLoad = 'admin.competence.list';
  protected rightNew = 'admin.competence.create';
  protected rightOpen = 'admin.competence.show';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    public transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.competences'));
    this.loading = true;
    this.api.getModels('competences').subscribe({
      next: (competences: any) => {
        this.competences = [];
        competences.data.forEach((competence: any) => {
          this.competences.push(new CompetenceModel().deserialize(competence));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
      if (this.auth.hasRight('admin.competence.edit') && this.competences.length > 1) {
        this.items = [{
          label: this.transloco.translate('common.labels.sequence'),
          icon: 'pi pi-list',
          command: () => {
            this.onStartOrdering();
          }
        }];
      }
    });
  }

  private onStartOrdering(): void {
    this.inOrdering = true;
    this.tempOrder = this.competences.map((competence: CompetenceModel) => competence.id);
  }

  onRowReorder(event: any): void {
    const ids = this.tempOrder.splice(event.dragIndex, 1);
    if (ids && ids.length > 0) {
      this.tempOrder.splice(event.dropIndex, 0, ids[0]);
    }
  }

  onCancel(): void {
    this.resetOrder();
    this.inOrdering = false;
    this.ui.hideMessage();
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.inOrdering === true) {
      this.submitting = true;
      const payload = {
        order: this.tempOrder
      };
      this.api.saveCompetencesOrder(payload).subscribe({
        next: (result: any) => {
          this.ui.hideMessage();
          this.ui.toastSuccess(this.transloco.translate('competence_list.sequence_saved'), this.transloco.translate('common.saved'));
          this.inOrdering = false;
          this.tempOrder = [];
          this.loadList();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
        }
      }).add(() => {
        this.submitting = false;
    });
    }
  }

  private resetOrder(): void {
    this.competences.sort((a: any, b: any) => (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0));
  }

}
